import { render, staticRenderFns } from "./MultiView.vue?vue&type=template&id=01aff967&scoped=true&"
import script from "./MultiView.vue?vue&type=script&lang=js&"
export * from "./MultiView.vue?vue&type=script&lang=js&"
import style0 from "./MultiView.vue?vue&type=style&index=0&id=01aff967&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aff967",
  null
  
)

export default component.exports